module.exports = __webpack_public_path__ + "media/images/ic-photos-46431b6afb50baa5b6a5d2b904ed66d2.svg";